export default __webpack_public_path__ + "static/media/daniel-cortild.1f4df13a.jpeg";